import React from 'react';
import '../../styles/table-main/main.css';

const Main = () => {
    return (
        <div id='tableMain'>
            <section className='table-main'>
                <div className="container my-5">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>RTI Act</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>RTI Act in Hindi 2015</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/rti-rules-hindi-2015.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td>RTI Act in English</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/RTI-Act[1]-English.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td>RTI Act in Hindi</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/RTI-Act-Hindi.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td>RTI [ Information to be published under Section 4(b) (i) ]</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/RTI.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                                <th>Budget Report</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>BUDGET 2019-2020</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/BUDGET-2019-2020.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td>BUDGET 2020-2021</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/BUDGET-2020-2021.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

        </div>
    )
}

export default Main;